import React from 'react'
import axios from 'axios';
import utils from '../Utils';
import { Button } from '@material-ui/core';
import { blue } from '@material-ui/core/colors';
import { Link } from 'react-router-dom'
import Hospital from './Hospital'

import style from 'style/Hospital.css'

class Hospitals extends React.Component {
  componentDidMount() {

  }

  render() {
    return (
      <div style={{ flexGrow: 1 }}>
        <div className='hospitals-title'>
          به کجا مراجعه کنم؟
        </div>
        <div className="hospitals-container">

          <Hospital />
          <Hospital />
          <Hospital />
          <Hospital />
          <Hospital />
          <Hospital />
          <Hospital />
        </div>
      </div>
    )
  }
}
export default Hospitals;